<template>
  <div class="zurich-card-brochure">
    <div v-for="item in items" :key="item.text" :style="item.style">
      + {{ item.text }}
    </div>
    <div>
      <div>= CHF 29 (24h)</div>
      <div>= CHF 56 (72h)</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface ZurichCardImageItem {
  text: string
  style: Record<string, string>
}

function getItem(text: string, color: string): ZurichCardImageItem {
  return {
    text,
    style: {
      color: `rgb(var(--color-${color}) / 1)`,
    },
  }
}

const items = [
  getItem('Public Transport', 'primary'),
  getItem('Boat Cruises', 'warning'),
  getItem('Cable Cars', 'danger'),
  getItem('Museums', 'violett'),
  getItem('Tours', 'sky'),
  getItem('Culture', 'orange'),
  getItem('Gastronomy', 'burgundy'),
  getItem('Experiences', 'success'),
  getItem('Shopping', 'pink'),
]
</script>

<style lang="postcss">
.zurich-card-brochure {
  @apply border border-solid border-border font-bold;
  font-size: 0.8em;
  padding: 0.75em;
  line-height: 1.25;
  box-shadow: 1px 3px 7px 0px rgb(210, 210, 210);
  @media (prefers-color-scheme: dark) {
    box-shadow: 1px 3px 7px 0px black;
  }

  > div {
    @apply whitespace-nowrap;
    &:last-child {
      @apply text-scheme-invert;
      border-top: 2px solid black;
      margin-top: 0.25em;
      padding-top: 0.25em;

      @media (prefers-color-scheme: dark) {
        border-top: 2px solid white;
      }
    }
  }
}
</style>
